
      import API from "!../../../../../../../style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../../style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/singletonStyleDomAPI.js";
      import insertFn from "!../../../../../../../style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../../style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/setAttributesWithAttributesAndNonce.js";
      import insertStyleElement from "!../../../../../../../style-loader@3.3.4_webpack@5.90.0/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      
      import content, * as namedExport from "!!../../../../../../../css-loader@6.10.0_webpack@5.90.0/node_modules/css-loader/dist/cjs.js!../../../../../../../postcss-loader@8.1.0_postcss@8.4.33_typescript@5.3.3_webpack@5.90.0/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./dropdown.css";
      
      

var options = {"attributes":{"data-cke":true}};

;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../../css-loader@6.10.0_webpack@5.90.0/node_modules/css-loader/dist/cjs.js!../../../../../../../postcss-loader@8.1.0_postcss@8.4.33_typescript@5.3.3_webpack@5.90.0/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./dropdown.css";
       export default content && content.locals ? content.locals : undefined;
